import React, { useEffect, useState } from 'react';
import { Box, useMediaQuery, useTheme } from '@mui/material';
import Navbar from '../components/Navbar';
import Sidebar from '../components/Sidebar';

export default function AdminLayout({ children, title }) {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));
    const [sidebarOpen, setSidebarOpen] = useState(false);

    useEffect(() => {
        if (!isMobile) {
            setSidebarOpen(true);
        } else {
            setSidebarOpen(false);
        }
    }, [isMobile]);

    return (
        <Box
            sx={{
                display: 'flex',
                height: '100%',
                width: '100%',
                overflow: 'hidden',
                bgcolor: '#f5f5f5',
            }}
        >
            {/* Sidebar */}
            <Sidebar
                open={sidebarOpen}
                onToggle={(nextOpen) => setSidebarOpen(!!nextOpen)}
            />

            {/* Main Content Area */}
            <Box
                sx={{
                    flex: 1,
                    display: 'flex',
                    flexDirection: 'column',
                    minWidth: 0,
                }}
            >
                {/* Navbar (fixed height) */}
                <Box sx={{ flexShrink: 0 }}>
                    <Navbar
                        title={title}
                        onMenuClick={() => setSidebarOpen(true)}
                    />
                </Box>

                {/* SCROLL CONTAINER */}
                <Box
                    sx={{
                        flex: 1,
                        minHeight: 0,     // 🔥 CRITICAL
                        overflowY: 'auto',
                        px: { xs: 1, sm: 2 },
                    }}
                >
                    {children}
                </Box>
            </Box>
        </Box>
    );
}
